import React from "react";

export default class LetterPanelBody extends React.Component {
  render() {
    return <div className="letter-panel-body">{this.props.children}</div>;
  }
}
